<template>

    <div v-loading="loading" >
        <!-- 头部信息 -->
        <div style="margin-top:20px;" class="viewKPITitle">
            <el-row style="margin-top:10px;">
                <el-col :span="6">
                    被考核者姓名：<span v-if="KPIItems.length>0">{{AllKPIInfo.userName}}</span>
                </el-col>
                <el-col :span="6">
                    被考核者岗位：<span v-if="KPIItems.length>0">{{AllKPIInfo.duty}}</span>
                </el-col>
                <el-col :span="6">
                    被考核者工号：<span v-if="KPIItems.length>0">{{userCode}}</span>
                </el-col>
                <el-col :span="6">
                    考核周期：<span v-if="KPIItems.length>0">{{AllKPIInfo.period}}{{pType==0?'月':'季度'}}</span>
                </el-col>
            </el-row>
            <el-row style="margin-top:10px;">
                <el-col :span="6">
                    考核者姓名：<span v-if="KPIItems.length>0">{{AllKPIInfo.leadName}}</span>
                </el-col>
                <el-col :span="6">
                    <!-- {{viewKPITitle.Period}}{{viewKPITitle.PeriodType==1?'季度':'月'}} -->
                    考核者岗位：<span v-if="KPIItems.length>0">{{AllKPIInfo.leadDuty}}</span>
                </el-col>
            </el-row>
        </div>
        <!-- 考核列表信息 -->
        <el-table border :data="KPIItems" show-summary :summary-method="getSummaries" style="width:100%;margin-top:20px;" v-loading="loading" size="small">
            <el-table-column min-width="20" prop="KPI"  label="KPI名称"></el-table-column>
            <el-table-column  min-width="20" prop="Explain" label="指标说明"></el-table-column>
            <el-table-column  min-width="20" prop="Contents" label="考核细则"></el-table-column>            
            <el-table-column  min-width="10" label="KPI类型">
                <template slot-scope="scope">
                    {{scope.row.KPIType == 0 ? "职能" : (scope.row.KPIType == 1 ? "业绩" : (scope.row.KPIType == 2 ? "自定义" : (scope.row.KPIType == 3 ? "其它" : (scope.row.KPIType == 4 ? "内部管理指标" : (scope.row.KPIType == 5 ? "客户指标" : (scope.row.KPIType == 6 ? "敬业度" : (scope.row.KPIType == 7 ? "重点项目" : "团队管理")))))))}}
                </template>
            </el-table-column>
            <el-table-column min-width="10" label="周期">
                <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
            </el-table-column>
            <el-table-column min-width="10" prop="KPIWeight" label="KPI权重"></el-table-column>
            <el-table-column min-width="10" prop="Execution" label="完成情况"></el-table-column>
            <el-table-column min-width="10" label="自评评分">
                <template slot-scope="scope">
                    {{scope.row.Status == 0 ?'':scope.row.SelfScore}}
                </template>
            </el-table-column>
            <el-table-column min-width="10" prop="LeadScore" label="直属领导评分">
                <template slot-scope="scope">
                    {{scope.row.LeadStatus == 0 ?'':scope.row.LeadScore}}
                </template>
            </el-table-column>
        </el-table>
    </div>
  
</template>
<script>
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetMyKPI,UpdateSelfScore,GetMyKPIScore } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
    props: {
        pt: {
            Type: Number
        },
        activeName:{
            Type:String
        }
    },
    data(){
        return{
            pType: this.pt,
            loading:true,
            userinfo:{},
            userCode:'',//被考核者工号
            AllKPIInfo:{},
            KPIItems:[],
            yearValue:'',//季度选择年
            year:'',//选择年
            month:'',//选择月
            dateMonth:'',//当前选择月份
            dateJidu:'',//季度
            formLabelWidth:'120px',
            SelfScoreModel:{
                Id:'',//当前kpi id
                userCode:'',//当前登录人工号
                SelfScore:0,//自评分数
                Execution:'',//完成情况
            }
        }
    },
    created() {
        //获取当前登录用户信息
        this.GetUserinfo();
        
        var date=new Date();
        this.year=date.getFullYear();
        this.month=date.getMonth();
        if(this.month==12){
            //如果上个月是12月，则年份减1为上个月
            this.year=this.year-1;
        }

        //获取上个季度数据
        if(this.pType==1){
            this.month=this.month+1;
            //季度时 选择当前季度
            if(this.month>=1&&this.month<=3){
                this.month='Q4';
            }
            else if(this.month>=4&&this.month<=6){
                this.month='Q1';
            }
            else if(this.month>=7&&this.month<=9){
                this.month='Q2';
            }
            else{
                this.month='Q3';
            }
        }
        if(this.month==0){
            this.month=12;
        }
        if(this.month==12||this.month=='Q4'){
            //如果上个月是12月，则年份减1为上个月
            this.year=this.year-1;
        }
        //获取我的KPI
        this.GetMyKPI();
    },
    methods: {
        //获取当前登录用户信息
        GetUserinfo:function(){
            this.userinfo=GetCurrentUserInfo();
            this.userCode=this.userinfo.UserCode;
        },
        //获取我的KPI
        GetMyKPI:async function(year,month){
            
            await GetMyKPI(this.userinfo.UserCode,this.pType,this.month,this.year).then(res=>{
                this.AllKPIInfo=res;
                this.KPIItems=res.list;
                this.loading=false;
            });
        },
        //获取合计列
        getSummaries:function(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                else if(index === 1){
                    //第七列 自评分数合计
                    var quanzhong=0;
                    param.data.forEach((column, index) => {
                        quanzhong+=column.KPIWeight;
                    })
                    sums[index]=quanzhong;
                }
                else if(index === 7){
                    //第七列 自评分数合计
                    var SelfScoreAll=0;
                    param.data.forEach((column, index) => {
                        SelfScoreAll+=column.SelfScore;
                    })
                    sums[index]='自评总分：'+SelfScoreAll.toFixed(2);
                }
                else if(index===8){
                    //第八列 领导评分合计
                    var leadScoreAll=0;
                    param.data.forEach((column, index) => {
                        leadScoreAll+=column.LeadScore;
                    })
                    sums[index]='领导评分：'+leadScoreAll.toFixed(2);
                }
                
            });

            return sums;
        }
    },
}
</script>
<style lang="less" scoped>
.viewKPITitle {
  text-align: left;
  font-size: 14px;
  color: #72767b;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
.el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
    color:red !important;
}

</style>